import http from "./http";

class PeriodiquesService {
    index(){
        return http.get("/api/periodiques")
    }

    store(data,token){
        return http.post("/api/periodiques/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/periodiques/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/periodiques/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/periodiques/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/periodiques/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    getTitrePeriodique(data,token){
        return http.post("/api/publications/titre", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new PeriodiquesService()